/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Aaf_Embed_LinkedInputs */

const en_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF Embed (Linked MXF)`)
};

const fr_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration AAF (MXF lié)`)
};

const de_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF-Einbettung (verknüpfte MXF-Datei)`)
};

const it_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF Embed (MXF collegato)`)
};

const ru_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивание AAF (связанный MXF)`)
};

const es_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integración de AAF (MXF vinculado)`)
};

const zh_cn2_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF 嵌入（链接 MXF）`)
};

const ja_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF埋め込み（リンクされたMXF）`)
};

const hi_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एएएफ एम्बेड (लिंक्ड एमएक्सएफ)`)
};

const pt_pt2_subtitle_export_aaf_embed_linked = /** @type {(inputs: Subtitle_Export_Aaf_Embed_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporação AAF (MXF vinculado)`)
};

/**
* | output |
* | --- |
* | "AAF Embed (Linked MXF)" |
*
* @param {Subtitle_Export_Aaf_Embed_LinkedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_aaf_embed_linked = /** @type {((inputs?: Subtitle_Export_Aaf_Embed_LinkedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Aaf_Embed_LinkedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_aaf_embed_linked(inputs)
	if (locale === "de") return de_subtitle_export_aaf_embed_linked(inputs)
	if (locale === "it") return it_subtitle_export_aaf_embed_linked(inputs)
	if (locale === "ru") return ru_subtitle_export_aaf_embed_linked(inputs)
	if (locale === "es") return es_subtitle_export_aaf_embed_linked(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_aaf_embed_linked(inputs)
	if (locale === "ja") return ja_subtitle_export_aaf_embed_linked(inputs)
	if (locale === "hi") return hi_subtitle_export_aaf_embed_linked(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_aaf_embed_linked(inputs)
	return en_subtitle_export_aaf_embed_linked(inputs)
});